import EventHandler from '../../events/event_handler';
import ImportedFlashMessagesEvents from './flash_messages_events';

export const FlashMessagesEvents = ImportedFlashMessagesEvents;
export const FlashMessagesEventHandler = new EventHandler(Object.values(FlashMessagesEvents));

export default FlashMessagesEventHandler;
